<template>
  <div class="trophies">
    <div class="header">
      <div class="header_section">
        <router-link to="/profile" class="header_element header_icone">
          <!--          <span class="icon icon-left-arrow icon-lg"></span>-->
          <font-awesome-icon color="#00d7fe" class="reverse" icon="angle-right"/>

        </router-link>
        <h1 class="header_element">Trophés</h1>
      </div>
    </div>
    <div class="content">
      <div class="content_section" v-if="trophiesList && trophiesList.length > 0">
        <div class="content-trophie" v-for="(trophie,index) in trophiesList" :class="{'own': checkTrophie(trophie.id)}">

          <img width="100%" :src="trophie.icon" alt=""
               v-if="checkTrophie(trophie.id) || user.user_type!=='Utilisateur'">
          <img src="icon/icon-lock.png" :style="'background:no-repeat center/contain url('+trophie.icon+')'" alt=""
               v-else>

          <!--          <div class="content-text">-->
          <!--            <p>{{trophie.name}}</p>-->
          <!--          </div>-->

        </div>
      </div>
      <div v-else class="empty-case">
        <div class="empty">AUCUN TROPHÉ DÉBLOQUÉ</div>
      </div>
    </div>
  </div>
</template>
<script>
import {store} from '../store/store';
import {mapState, mapActions} from "vuex";

export default {
  name: 'Trophies',
  data() {
    return {
      user: store.getters.getUser,
      trophiesList: null,
      trophies: null
    }
  },
  methods: {
    ...mapActions([
      'getSuccess',
      'getUserSuccess'
    ]),
    checkTrophie(id) {
      return this.trophies ? this.trophies.find(res => res.id === id) : false;
    },
  },
  computed: {
    ...mapState([
      "masks",
    ])
  },
  mounted() {
    !localStorage.getItem('user') && this.$router.push({name: "login", params: {type: 'connexion'}});
    toggleLoader()
    this.getSuccess().then(res => {
          this.trophiesList = res
          toggleLoader()
        }
    )
    this.getUserSuccess().then(res => {
      this.trophies = res
    })

  }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');

.header {
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
}

.trophies {
  z-index: 1;
  background: #fff;
  margin-bottom: 40px;
}

.empty-case {
  display: flex;
}

.empty-case > * {
  color: #bebebe;
  font-family: Poppins;
  padding: 20px;
  margin: auto;
}

.header_icone {
  font-size: 30px;
  /*line-height: 80px;*/
}

.header_section {
  display: flex;
  align-items: center;
}

.header_section:first-child {
  justify-content: center;
  width: 100%;
}

.header_section:first-child .header_element:first-child {
  position: absolute;
  left: 10px;
}

.header_element {
  margin: 0 0 0 10px;
  color: #00d7fe;
  text-decoration: none;
}

h1.header_element {
  font-size: 3em;
  /*border-bottom:4px solid #00d7fe;*/
  padding: 0;
  position: relative;
}

.content_section {
  padding: 20px;
  display: flex;
  /*justify-content: space-between;*/
  flex-wrap: wrap;
}

.content-trophie {
  width: 20%;
  margin: 10px;
  display: flex;
  justify-content: center;
  padding: 8px;
  border: 2px solid var(--main-color);
  border-radius: 10px;
  font-family: var(--main-body-font);
}


.content_name {
  text-align: center;
  color: #00d6ff;
  font-size: 35px;
  margin: 0;
  font-family: 'Bebas Neue', cursive;
  letter-spacing: 2px;
}

span {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.content_img {
  width: 150px;
  border-radius: 100%;
  height: auto;
  margin: auto;
}

.content_element_link {
  margin: auto 0;
  font-size: 20px;
}

.content_element_icon_arrow {
  font-size: 40px;
  color: #fff;
  padding-right: 10px;
}

.content_element_icon_description {
  font-size: 50px;
  padding-left: 10px;
}

a {
  text-decoration: none;
}

a.addinsta {
  color: #00a6d9;
}

@media screen and (min-width: 750px) {

  .content_section {
    /*width: 70%;*/
    /*margin: auto;*/
    /*margin-top:30px;*/
  }
}
</style>
